import { BusinessAccount } from '@/app/common/general-types/business-account.dto';
import { Component, effect, inject, Input, OnChanges, signal, SimpleChanges } from '@angular/core';
import { PricingModelV2Service } from '@/app/services/pricing-model-v2/pricing-model-v2.service';
import { take } from 'rxjs';
import { DatePipe } from '@angular/common';
import { BriefResponseDto, BriefStatusEnum, UgcBriefFilterStatsDtoV2 } from '@/app/common/general-types/briefs.dto';
import { BrandInsightsState } from '../../brand-insights.state';

@Component({
  selector: 'brand-ins-pricing-models',
  imports: [DatePipe],
  templateUrl: './pricing-models.html',
  styleUrl: './pricing-models.css',
  host: { class: 'block h-full min-h-0 w-full min-w-0' },
})
export class PricingModels implements OnChanges {
  @Input() brand: BusinessAccount | undefined;

  modelsWithBriefs = signal<any[] | undefined>(undefined);

  expandedModelId = signal<string[]>([]);

  /** Services */
  private pmv2Service = inject(PricingModelV2Service);
  private brandState = inject(BrandInsightsState);
  /** Services - END */

  constructor() {
    effect(() => {
      const fromState = this.brandState.brand();
      if (fromState && fromState.id !== this.brand?.id) {
        this.brand = fromState;
        this.getBrandModelsAndUsage();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('😎😎😎 FOCUSED BRAND 😎😎😎 ', this.brand);

    this.getBrandModelsAndUsage();
  }

  getBrandModelsAndUsage() {
    this.pmv2Service.getBrandModelsAndUsage(this.brand!.id).pipe(take(1)).subscribe((res) => {
      console.log('Brand Models and Usage: ', res);
      this.modelsWithBriefs.set(res);
    }, error => {
      console.error('Error getting brand models and usage: ', error);
      this.modelsWithBriefs.set(undefined);
    });
  }

  toggleExpandedModel(modelId: string) {
    if (this.expandedModelId().includes(modelId)) {
      this.expandedModelId.set(this.expandedModelId().filter(id => id !== modelId));
    } else {
      this.expandedModelId.set([...this.expandedModelId(), modelId]);
    }
  }

  getActiveDotColour(brief: UgcBriefFilterStatsDtoV2) {
    switch (brief.currentStatus.status) {
      case BriefStatusEnum.Public:
        return 'fill-green-500';
      case BriefStatusEnum.Private:
        return 'fill-yellow-500';
      case BriefStatusEnum.Complete:
        return 'fill-gray-500';
      case BriefStatusEnum.Deleted:
        return 'fill-red-500';
      case BriefStatusEnum.Draft:
        return 'fill-blue-500';
      default:
        return 'fill-gray-500';
    }
  }

  getStatus(brief: UgcBriefFilterStatsDtoV2) {
    switch (brief.currentStatus.status) {
      case BriefStatusEnum.Public:
        return 'Open';
      case BriefStatusEnum.Private:
        return 'Invite Only';
      case BriefStatusEnum.Complete:
        return 'Complete';
      case BriefStatusEnum.Deleted:
        return 'Deleted';
      case BriefStatusEnum.Draft:
        return 'Draft';
      default:
        return 'Draft';
    }
  }

  getActiveColour(brief: UgcBriefFilterStatsDtoV2) {
    switch (brief.currentStatus.status) {
      case BriefStatusEnum.Public:
        return 'text-green-700 ring-green-600/20 bg-green-50 dark:bg-green-400/10 dark:text-green-400 dark:ring-green-400/30';
      case BriefStatusEnum.Private:
        return 'text-amber-800 ring-amber-600/25 bg-amber-50 dark:bg-amber-400/10 dark:text-amber-300 dark:ring-amber-400/35';
      case BriefStatusEnum.Complete:
        return 'text-gray-700 ring-gray-500/25 bg-gray-100 dark:bg-gray-400/10 dark:text-gray-300 dark:ring-gray-400/30';
      case BriefStatusEnum.Deleted:
        return 'text-red-700 ring-red-600/20 bg-red-50 dark:bg-red-400/10 dark:text-red-400 dark:ring-red-400/30';
      case BriefStatusEnum.Draft:
        return 'text-blue-700 ring-blue-600/20 bg-blue-50 dark:bg-blue-400/10 dark:text-blue-400 dark:ring-blue-400/30';
      default:
        return 'text-gray-700 ring-gray-500/25 bg-gray-100 dark:bg-gray-400/10 dark:text-gray-300 dark:ring-gray-400/30';
    }
  }

}
